import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import { ThemeConfig, ACSTheme, ACSSpacing } from 'src/app/utils/interfaces';

@Component({
  selector: 'acs-theme-selector',
  templateUrl: './theme-selector.html',
  styleUrls: ['./theme-selector.scss']
})
export class ThemeSelectorComponent implements OnInit {
  currentTheme: ACSTheme = 'default';
  currentSpacing: ACSSpacing = 'default';
  customColors = {
    primary: '',
    secondary: '',
    accent: ''
  };

  availableThemes: Array<{ value: ACSTheme; label: string; description: string }> = [];
  availableSpacing: Array<{ value: ACSSpacing; label: string; description: string }> = [];

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.availableThemes = this.themeService.getAvailableThemes();
    this.availableSpacing = this.themeService.getAvailableSpacing();
    this.themeService.theme$.subscribe((config: ThemeConfig) => {
      this.currentTheme = config.theme;
      this.currentSpacing = config.spacing;
      if (config.customColors) {
        this.customColors = {
          primary: config.customColors.primary || '',
          secondary: config.customColors.secondary || '',
          accent: config.customColors.accent || ''
        };
      }
    });
  }

  onThemeChange(theme: ACSTheme): void {
    this.themeService.setTheme(theme);
  }

  onSpacingChange(spacing: ACSSpacing): void {
    this.themeService.setSpacing(spacing);
  }

  onCustomColorChange(): void {
    const colors = {
      primary: this.customColors.primary || undefined,
      secondary: this.customColors.secondary || undefined,
      accent: this.customColors.accent || undefined
    };
    this.themeService.setCustomColors(colors);
  }

  resetTheme(): void {
    this.themeService.resetTheme();
    this.customColors = {
      primary: '',
      secondary: '',
      accent: ''
    };
  }

  toggleDarkMode(): void {
    this.themeService.toggleDarkMode();
  }
}
